export function DuplicateCpAlert(clientName) {
  return {
    title: `Create Replica of ${clientName}`,
    html: `
    <div style="display: flex; flex-direction: column; place-items: baseline">
        <div style="font-weight: 900;">Client Name</div><input id="swal-input1" class="swal2-input" placeholder="Enter Client Name">
        <div style="font-weight: 900;">Contact Name</div><input id="swal-input2" class="swal2-input" placeholder="Enter Contact Name"> 
        <div style="font-weight: 900;">Contact Email</div><input id="swal-input3" class="swal2-input" placeholder="Enter Contact Email">
        <div style="font-weight: 900;">Password</div><input id="swal-input4" class="swal2-input" placeholder="Enter Password" type="password">
        <small style="font-weight:bold; margin-top:1vh; margin-bottom:-1vh" class="font-weight-bold">Your password must not contain any blank spaces and meet the following criteria:</small>
        <ul class="list-icon pt-3" style="text-align: start; margin-bottom: 0;">
          <li id="characters" style="margin-top: 0.25rem;" class="icon-check-circle-o muted">8 characters</li>
          <li id="upperAndLower" style="margin-top: 0.25rem;" class="icon-check-circle-o muted">Uppercase and lowercase letters</li>
          <li id="numbers" style="margin-top: 0.25rem;" class="icon-check-circle-o muted">Number(s)</li>
          <li id="specialCharacters" style="margin-top: 0.25rem;" class="icon-check-circle-o muted">Special character(s)</li>
        </ul>
        <div id="progressBarResponse"></div>
        <progress id="passworProgress" value="0" max="100" style="width: 100%; height: 3vh;  margin-bottom:1vh; background-color: grey; background: white;"></progress>
        <div style="font-weight: 900;">Confirm Password</div><input id="swal-input5" class="swal2-input" placeholder="Enter Password" type="password">
      </div>
      `,
    showCancelButton: true,
    showConfirmButton: true,
    reverseButtons: true,
    confirmButtonText: 'Create Replica',

    preConfirm: function () {
      return new Promise(function (resolve) {
        const swalInput1 = document.getElementById('swal-input1');
        const swalInput2 = document.getElementById('swal-input2');
        const swalInput3 = document.getElementById('swal-input3');
        const password = document.getElementById('swal-input4');
        const confirmPassword = document.getElementById('swal-input5');
        const progressBarResponse = document.getElementById('progressBarResponse');
        const passwordProgress = document.getElementById('passworProgress');

        if (
          swalInput1 === null ||
          swalInput2 === null ||
          swalInput3 === null ||
          password === null ||
          confirmPassword === null ||
          progressBarResponse === null ||
          passwordProgress === null
        ) {
          resolve(false);
        }

        if (swalInput1 != null && !swalInput1.value && swalInput1.value.length <= 0) {
          swalInput1.classList.add('is-invalid');
          swalInput1.onclick = function () {
            swalInput1?.classList.remove('is-invalid');
          };
          resolve(false);
        }
        if (swalInput2 != null && !swalInput2.value && swalInput2.value.length <= 0) {
          swalInput2.classList.add('is-invalid');
          swalInput2.onclick = function () {
            swalInput2?.classList.remove('is-invalid');
          };
          resolve(false);
        }

        if (swalInput3 != null && !swalInput3.value && swalInput3.value.length <= 0) {
          swalInput3?.classList.add('is-invalid');
          swalInput3.onclick = function () {
            swalInput3?.classList.remove('is-invalid');
          };
          resolve(false);
        }

        const regex = /\S+@\S+\.\S+/;
        const validEmail = regex.test(swalInput3.value);
        if (!validEmail) {
          swalInput3?.classList.add('is-invalid');
          resolve(false);
        }

        if (password != null && passwordProgress && passwordProgress.value < 99) {
          const progressWidth = passwordProgress.value;
          if (progressWidth < 99) {
            password.classList.add('is-invalid');
          }
          password.classList.add('is-invalid');
          password.onclick = function () {
            password?.classList.remove('is-invalid');
          };
          resolve(false);
        }

        if (password != null && confirmPassword && password.value !== confirmPassword.value) {
          password.classList.add('is-invalid');
          confirmPassword.classList.add('is-invalid');
          password.onclick = function () {
            password?.classList.remove('is-invalid');
            confirmPassword?.classList.remove('is-invalid');
            confirmPassword.value = '';
          };
          confirmPassword.onclick = function () {
            confirmPassword?.classList.remove('is-invalid');
          };
          resolve(false);
        }
        resolve([swalInput1.value, swalInput2.value, swalInput3.value, password.value]);
      });
    },
    onOpen: function () {
      const password = document.getElementById('swal-input4');
      if (password === null) return;
      password.addEventListener('input', {
        handleEvent: function (event) {
          const passwordProgress = document.getElementById('passworProgress');
          const progressBarResponse = document.getElementById('progressBarResponse');

          const characters = document.getElementById('characters');
          const upperAndLower = document.getElementById('upperAndLower');
          const numbers = document.getElementById('numbers');
          const specialCharacters = document.getElementById('specialCharacters');
          var styleElem = document.head.appendChild(document.createElement('style'));

          if (passwordProgress === null || progressBarResponse === null) return;
          const passwordValue = event.target.value;
          const hasLowercaseUppercase = /[a-z]/.test(passwordValue) && /[A-Z]/.test(passwordValue);
          const hasNumber = /\d/.test(passwordValue);
          const hasSpecialChar = /[^A-Za-z0-9]/.test(passwordValue);

          passwordProgress.value = passwordValue.length;
          if (passwordProgress.value < 0) passwordProgress.value = 0;
          if (passwordProgress.value > 100) passwordProgress.value = 100;

          if (characters === null || upperAndLower === null || numbers === null || specialCharacters === null) return;

          if (passwordValue.length <= 0) {
            styleElem.innerHTML += '#characters::before {color: grey;}';
            styleElem.innerHTML += '#upperAndLower::before {color: grey;}';
            styleElem.innerHTML += '#numbers::before {color: grey;}';
            styleElem.innerHTML += '#specialCharacters::before {color: grey;}';
            characters.style.color = 'grey';
            upperAndLower.style.color = 'grey';
            numbers.style.color = 'grey';
            specialCharacters.style.color = 'grey';
            passwordProgress.value = 0;
          } else {
            if (passwordValue.length >= 8) {
              passwordProgress.value += 25;
              styleElem.innerHTML += '#characters::before {color: green;}';
              characters.style.color = 'green';
            } else {
              characters.style.color = 'red';
              styleElem.innerHTML += '#characters::before {color: red;}';
            }
            if (hasLowercaseUppercase) {
              upperAndLower.style.color = 'green';
              passwordProgress.value += 25;
              styleElem.innerHTML += '#upperAndLower::before {color: green;}';
            } else {
              upperAndLower.style.color = 'red';
              styleElem.innerHTML += '#upperAndLower::before {color: red;}';
            }
            if (hasNumber) {
              numbers.style.color = 'green';
              passwordProgress.value += 25;
              styleElem.innerHTML += '#numbers::before {color: green;}';
            } else {
              numbers.style.color = 'red';
              styleElem.innerHTML += '#numbers::before {color: red;}';
            }
            if (hasSpecialChar) {
              specialCharacters.style.color = 'green';
              passwordProgress.value += 25;
              styleElem.innerHTML += '#specialCharacters::before {color: green;}';
            } else {
              specialCharacters.style.color = 'red';
              styleElem.innerHTML += '#specialCharacters::before {color: red;}';
            }
            if (passwordProgress.value < 50) {
              styleElem.innerHTML += 'Progress::-webkit-progress-value {background-color: red;}';
            } else if (passwordProgress.value >= 75) {
              styleElem.innerHTML += 'Progress::-webkit-progress-value {background-color: green;}';
            } else if (passwordProgress.value < 75 && passwordProgress.value > 50) {
              styleElem.innerHTML += 'Progress::-webkit-progress-value {background-color: orange;}';
            }
          }
        },
      });
    },
  };
}
